module.exports = __webpack_public_path__ + "static/media/smart_banner_hero.fd7e200d.png";